import React from 'react'
import ClickableVideo from './ClickableVideo'
import { useLanguage } from '../contexts/LanguageContext'
import { translations } from '../translations/translations'
import { useNavigate } from 'react-router-dom'
import parfumeVideo from '../imgs/parfume.mp4'

const JewelleryCoutureCollection = () => {
  const { language } = useLanguage()
  const t = translations.featuredCollections
  const navigate = useNavigate()

  const handleSectionClick = (e) => {
    // Не переходить в shop если клик был на видео
    if (e.target.closest('.clickable-video-wrapper')) {
      return
    }
    navigate('/shop')
  }

  return (
    <section
      id="jewellery-couture"
      className="bg-white cursor-pointer"
      onClick={handleSectionClick}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 text-zinc-900">
        <div className="max-w-lg mx-auto flex flex-col">
          {/* Heading at the top of the section */}
          <div className="w-full text-center mb-6">
            <h2 className="text-xl md:text-2xl lg:text-3xl tracking-[0.15em] uppercase playfair">
              {language === 'ru'
                ? 'Дизайнер ювелирных украшений и моды'
                : 'JEWELLERY AND FASHION DESIGNER'}
            </h2>
          </div>
          
          {/* Centered video */}
          <div className="w-full">
            <div className="relative rounded-[2.5rem] overflow-hidden w-full h-[650px] md:h-[750px] lg:h-[850px]">
              <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/10 to-transparent pointer-events-none" />
              <ClickableVideo
                src={parfumeVideo}
                className="w-full h-full object-cover scale-100 transition-transform duration-[6000ms] hover:scale-105"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default JewelleryCoutureCollection
